import { useEffect, useState } from "react";

import { Tooltip } from "@mui/material";
import { RootStateOrAny, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { AuthState } from "store/ducks/auth/types";
import DialogCommon from "components/dialogCommon";
import ModalEspelho from "./components/modalEspelho";
import * as IconsSVG from "../../../../assets/iconsSVG";
import * as Styles from "./style";

interface Props {
  nomeBandeira: string;
  data: any;
}

const Header = (props: Props) => {
  const history = useHistory();
  const [color, setColor] = useState<string>("#8C6320");
  const [oportunityModal, setOportunityModal] = useState<boolean>(false);

  const { idCorretor2013 } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );

  useEffect(() => {
    switch (props?.data?.nomeBandeira) {
      case "CYRELA":
        setColor("#8C6320");
        break;
      case "LIVING":
        setColor("#242C57");
        break;
      case "VIVAZ":
        setColor("#960064");
        break;
      case "Outros":
        setColor("#000000");
        break;
      case "-":
        setColor("#000000");
        break;
      default:
        break;
    }
  }, [props?.data?.nomeBandeira]);

  const getTitle = () => {
    if (props.data?.nomeBandeira === "CYRELA") {
      return "Cyrela";
    }
    if (props.data?.nomeBandeira === "LIVING") {
      return "Living";
    }
    if (props.data?.nomeBandeira === "VIVAZ") {
      return "VIVAZ";
    }
    if (props.data?.nomeBandeira === "Outros") {
      return "Outros";
    }
    if (props.data?.nomeBandeira === "-") {
      return "Outros";
    }
    return "Outros";
  };
  return (
    <>
      <Styles.ProductsContainer>
        <Styles.HeaderContainer>
          <Styles.HeaderTop urlFoto={props?.data?.urlImagemPrincipal}>
            {props.data?.nomeBandeira === "Outros" ||
            props.data?.nomeBandeira === "-" ? (
              <></>
            ) : (
              <>
                <Tooltip title={getTitle()} placement="top" followCursor arrow>
                  <Styles.CicleBandeira>
                    {props.data?.nomeBandeira === "CYRELA" && (
                      <IconsSVG.CyrelaIcon />
                    )}
                    {props.data?.nomeBandeira === "LIVING" && (
                      <IconsSVG.LivingIcon />
                    )}
                    {props.data?.nomeBandeira === "VIVAZ" && (
                      <IconsSVG.VivazIcon />
                    )}
                  </Styles.CicleBandeira>
                </Tooltip>
                <Styles.StatusTag>
                  {" "}
                  {props.data?.statusEmpreendimento}{" "}
                </Styles.StatusTag>
              </>
            )}
          </Styles.HeaderTop>
          <Styles.HeaderBottom>
            <Styles.GridHeaderBottomLeft>
              <Styles.TitleHeader>
                {props.data?.nomeEmpreendimento}
              </Styles.TitleHeader>
              <Styles.SubtitleHeader
                style={{ textDecoration: "none" }}
                href={props?.data?.localizacao?.urlGoogleMaps}
                target="_blank"
              >
                {props?.data?.localizacao?.endereco},{" "}
                {props?.data?.localizacao?.numero} -{" "}
                {props?.data?.localizacao?.bairro}
                <IconsSVG.ExternalLinkWhite
                  viewBox="0 -3 29 16"
                  color="#2D5BFF"
                />
              </Styles.SubtitleHeader>
            </Styles.GridHeaderBottomLeft>
            <Styles.GridHeaderBottomRight>
              <Styles.Row>
                <Tooltip title="Dormitórios" placement="top" followCursor arrow>
                  <Styles.Item>
                    <IconsSVG.ProductRoomIcon
                      size="30"
                      viewBox="0 0 21 21"
                      color={color}
                    />
                    <Styles.TextItem>
                      {props.data?.quantidadeDormitorios || "--"}
                    </Styles.TextItem>
                  </Styles.Item>
                </Tooltip>
                <Tooltip title="Metragem" placement="top" followCursor arrow>
                  <Styles.Item>
                    <IconsSVG.ProductRegua
                      size="30"
                      viewBox="0 0 21 21"
                      color={color}
                    />
                    <Styles.TextItem>
                      {props.data?.metragemEmpreendimento || "--"}
                    </Styles.TextItem>
                  </Styles.Item>
                </Tooltip>
                <Tooltip
                  title="Vagas Garagem"
                  placement="top"
                  followCursor
                  arrow
                >
                  <Styles.Item>
                    <IconsSVG.ProductCar
                      size="30"
                      viewBox="0 0 25 21"
                      color={color}
                    />
                    <Styles.TextItem>
                      {props.data?.vagasGaragem || "--"}
                    </Styles.TextItem>
                  </Styles.Item>
                </Tooltip>
                <Tooltip title="Banheiros" placement="top" followCursor arrow>
                  <Styles.Item>
                    <IconsSVG.ProductBath
                      size="30"
                      viewBox="0 0 18 19"
                      color={color}
                    />
                    <Styles.TextItem>
                      {props.data?.quantidadeBanheiros || "--"}
                    </Styles.TextItem>
                  </Styles.Item>
                </Tooltip>
                {/* <Tooltip title="Blocos" placement="top" followCursor arrow>
                  <Styles.Item>
                    <IconsSVG.ProductPredio
                      size="30"
                      viewBox="0 0 21 21"
                      color={color}
                    />
                    <Styles.TextItem>
                      {props.data?.quantidadeTorres || "--"}
                    </Styles.TextItem>
                  </Styles.Item>
                </Tooltip>
                <Tooltip title="Pavimentos" placement="top" followCursor arrow>
                  <Styles.Item>
                    <IconsSVG.ProductLayer
                      size="30"
                      viewBox="0 0 21 21"
                      color={color}
                    />
                    <Styles.TextItem>
                      {props.data?.quantidadePavimentos || "--"}
                    </Styles.TextItem>
                  </Styles.Item>
                </Tooltip>
                <Tooltip title="Unidades" placement="top" followCursor arrow>
                  <Styles.Item>
                    <IconsSVG.ProductSala
                      size="30"
                      viewBox="0 0 23 21"
                      color={color}
                    />
                    <Styles.TextItem>
                      {props.data?.quantidadeUnidades || "--"}
                    </Styles.TextItem>
                  </Styles.Item>
                </Tooltip>
                <Tooltip
                  title="Unidades Disponíveis"
                  placement="top"
                  followCursor
                  arrow
                >
                  <Styles.Item>
                    <IconsSVG.ProductCheck
                      size="30"
                      viewBox="0 0 21 21"
                      color={color}
                    />
                    <Styles.TextItem>
                      {props.data?.quantidadeDisponivel || "--"}
                    </Styles.TextItem>
                  </Styles.Item>
                </Tooltip> */}
              </Styles.Row>
            </Styles.GridHeaderBottomRight>
          </Styles.HeaderBottom>
        </Styles.HeaderContainer>
        <div style={{ display: "flex", gap: "10px" }}>
          <Styles.BtnEV onClick={() => setOportunityModal(true)}>
            Espelho de vendas
          </Styles.BtnEV>
          {props?.data?.standEspelho !== null &&
            props?.data?.standEspelho !== undefined && (
              <Styles.BtnStand
                onClick={() => {
                  const params = new URLSearchParams({
                    url: props?.data?.standEspelho,
                    produtoNome: props?.data?.nomeEmpreendimento || "",
                    produtoCodigo: props?.data?.codigoSap || "",
                  });
                  history.push(`/stand-espelho?${params.toString()}`);
                }}
              >
                Stand Espelho
              </Styles.BtnStand>
            )}
        </div>
      </Styles.ProductsContainer>
      <DialogCommon
        closeText=""
        saveText=""
        onClose={() => setOportunityModal(false)}
        onSave={() => {}}
        titleHeader="Confirmação!"
        title="Qual bloco você gostaria de ver?"
        isRight={false}
        onClean={() => {}}
        isFilter={false}
        isClose
        width={600}
        marginBottom={54}
        component={
          <ModalEspelho
            idCorretor2013={idCorretor2013}
            product={props?.data?.idEmpreendimento}
            data={props?.data}
          />
        }
        setOpenModal={setOportunityModal}
        open={oportunityModal}
      />
    </>
  );
};

export default Header;
